const WobNamespaces = {
  wob: 'https://webofbuildings.com/',
  wobo: 'https://webofbuildings.com/ontology/',
}

export { WobNamespaces }
